import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';

import { ActivatedRoute, Params, Router } from '@angular/router';
import { SharedData } from '../shared-data/shared-object.service';
import { AccordionModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { CONTENT_TYPES, IDENTIFIERS, STATUS_CODES} from '../common/constants/defines';


@Component({
  selector: 'app-template-details',
  templateUrl: './template-details.component.html',
  styleUrls: ['./template-details.component.css']
  //  providers: [SharedData]
})
export class TemplateDetailsComponent implements OnInit {

  public statusCodes: string[] = STATUS_CODES;


  public encodes: string[] = ['base64', 'none'];
  public dataTypes: string[] = ['pairs', 'string'];
  public selectedStatusCode: string;
  public template: any = {};
  public serviceTemplate = {};
  public templates: any = [];
  public valueExists: boolean = false;
  public jsonNotValid: boolean = false;
  public invalidName: boolean = false;
  public stayOnpageFlag: boolean = false;
  public isEdit: boolean;
  public templatesObject;
  public currentTemplate;
  private serviceName: string;
  private respCode: string;
  public responseCodeDisabled: boolean = false;
  public cookie: any = {};
  public editMode: boolean = false;
  public header: any = {};

  public contentTypes = CONTENT_TYPES;
  public contentTypesName = IDENTIFIERS.contentType;
  public selectedContentType = this.contentTypes[0].contentType;



  // @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;




  constructor(private _router: Router, private route: ActivatedRoute, private _sharedData: SharedData) {
    // this.editorOptions = new JsonEditorOptions();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.serviceName = params['serviceName'];
      this.respCode = params['respCode'];
      if (!this.respCode) {
        this.isEdit = false;
      } else {
        this.isEdit = true;
      }
    });
    this.templatesObject = this._sharedData.getTemplatesByServiceId(this.serviceName);

    if (this.templatesObject) {
      for (let i = 0; i < this.templatesObject.length; i++) {
        if (this.templatesObject[i].code == this.respCode) {
          this.template.code = this.respCode;
          this.selectedContentType = this.templatesObject[i].contentType;
          this.template.bodyTemplate = this.templatesObject[i].template.ServiceBodyTemplate;
          this.template.defaultBody = JSON.stringify(this.templatesObject[i].template.defaultBody);
          this.template.cookies = this.templatesObject[i].cookies;
          this.template.headers = this.templatesObject[i].headers;
        }
      }
    }

    this.template.cookies = this.template.cookies || [];
    this.template.headers = this.template.headers || [];

    if (this.isEdit) {
      this.responseCodeDisabled = true;
    }
    if (!this.template.code) {
      this.template.code = '200'
    }

    //default values for cookie
    this.cookie.dataType = 'pairs';
    this.cookie.encode = 'base64';
    if (!this.isEdit) {
      let defaultHeader = { key: this.contentTypesName, value: this.selectedContentType };
      this.template.headers.push(defaultHeader);
    }


  }

  public addCookie(): void {
    this.invalidName = false;

    if (this.cookie.expires)
      this.cookie.expires = Number(this.cookie.expires);

    if (this.cookie.dataType == 'pairs' && this.cookie.data) {
      try {
        this.cookie.data = JSON.parse(this.cookie.data);
      } catch (error) {
        alert('invalid cookie json object is detected');
        return;
      }
    }

    if (!this.cookie.name) {
      this.invalidName = true;
    }
    for (let i = 0; i < this.template.cookies.length; i++) {
      if (this.template.cookies[i].name == this.cookie.name) {
        this.invalidName = true;
      }
    }


    if (this.cookie.domain == '')
      delete this.cookie.domain;

    if (!this.invalidName) {
      this.template.cookies.push(this.cookie);
      this.cookie = {}
    }
  }

  public addTemplate(): void {
    this.valueExists = false;
    let tempTemplateBody;
    if (this.selectedContentType != this.contentTypes[1].contentType) {

      if (!this.validateJSON(this.template.defaultBody)) {

        this.jsonNotValid = true;
        return;
      }

      tempTemplateBody = JSON.parse(this.template.defaultBody);

    } else {

      tempTemplateBody = this.template.defaultBody;
    }
    this.serviceTemplate = {
      "code": this.template.code,
      "content-type": this.selectedContentType,
      "template": {
        "ServiceBodyTemplate": this.template.bodyTemplate,
        "defaultBody": tempTemplateBody,
      },
      "cookies": this.template.cookies,
      "headers": this.template.headers
    }

    if (this.templatesObject) {
      for (let i = 0; i < this.templatesObject.length; i++) {
        if (this.templatesObject[i].code == this.template.code) {
          if (this.isEdit) {
            this.templatesObject[i] = this.serviceTemplate;
          } else {
            this.valueExists = true;
            this.stayOnpageFlag = true;
          }
        }
      }
    }

    if (!this.valueExists && !this.isEdit) {
      // this.templates.push(Object.assign({}, this.serviceTemplate));
      this._sharedData.setTemplateByServiceId(this.serviceName, this.serviceTemplate);
      this.template.code = '';
      this.template.bodyTemplate = '';
      this.template.defaultBody = '';
    }
    if (!this.stayOnpageFlag) {
      this.templates = [];
      this._router.navigate(['/servicedetails/' + this.serviceName]);
    }

  }

  public onChange(newVal): void {
    this.selectedStatusCode = newVal;
  }

  public closeOverlay() {
    this._router.navigate(['/servicedetails/' + this.serviceName]);
  }

  public validateJSON(object: any): boolean {
    if (/^[\],:{}\s]*$/.test(object.replace(/\\["\\\/bfnrtu]/g, '@').
      replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
      replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      return true;
    } else {
      return false;
    }
  }

  // public setTreeMode() {
  //   this.editor.setMode('tree');
  // }
  public editCookie(cookie, index) {
    if (cookie.dataType == 'pairs' && cookie.data) {
      try {
        cookie.data = JSON.stringify(cookie.data, undefined, 4);
      } catch (error) {
        alert('invalid cookie json object is detected');
        return;
      }
    }
    this.cookie = cookie;
    this.editMode = true;
    this.template.cookies.splice(index, 1);
  }

  public deleteCookie(index) {
    this.template.cookies.splice(index, 1);
  }
  public EditCurrentCookie(cookie) {
    if (cookie.dataType == 'pairs' && cookie.data) {
      try {
        cookie.data = JSON.parse(cookie.data);
      } catch (error) {
        alert('invalid cookie json object is detected');
        return;
      }
    }
    this.template.cookies.push(cookie)
    this.cookie = {}
    this.editMode = false;
    this.cookie.dataType = 'pairs';
    this.cookie.encode = 'base64';
  }

  public addHeader(): void {
    this.template.headers.push(this.header);
    this.header = {};
  }

  public editHeader(header, index) {
    this.header = header;
    this.template.headers.splice(index, 1);
  }

  public deleteHeader(index) {
    this.template.headers.splice(index, 1);
  }

  public checkHeader(header, i) {

    if (header.key === this.contentTypesName) {
      return true;
    }
    return false;

  }
  public onChangeContentType($event) {
    let tempHeader = { key: this.contentTypesName, value: $event };
    this.template.headers[0] = tempHeader;
    this.selectedContentType = $event;
  }

}



// WEBPACK FOOTER //
// ./src/app/template-details/template-details.component.ts